import { useEffect } from 'react';

const useOnClickOutside = (refs, handler, isTriggerTouchStart) => {
    useEffect(
        () => {
            const listener = (event) => {
                const isCallHandler = refs.every((ref) => (ref.current && !ref.current.contains(event.target)));
                if (isCallHandler) handler();
            };
            document.addEventListener('mousedown', listener);

            if (isTriggerTouchStart) {
                document.addEventListener('touchstart', listener);
            }

            return () => {
                document.removeEventListener('mousedown', listener);

                if (isTriggerTouchStart) {
                    document.removeEventListener('touchstart', listener);
                }
            };
        },
        [refs, handler, isTriggerTouchStart],
    );
};

export default useOnClickOutside;
